import {isBoolean} from 'lodash';

import {CollapsedItemKeyPrefixesEnum} from '../models/api/localPreferencesModel';

/*
 * Types.
 */

export type CollapsedStateKey = string;

export type IsExpandedPredicate = (key: CollapsedStateKey, defaultValue: boolean) => boolean;

export interface CollapsedItemStates {
  [key: CollapsedStateKey]: boolean;
}

/*
 * Helpers.
 */

export function computeIsItemExpanded(
  collapsedItems: CollapsedItemStates,
  key: string,
  defaultExpandedState: boolean,
) {
  const isCollapsed = collapsedItems[key];
  return isBoolean(isCollapsed) ? !isCollapsed : defaultExpandedState;
}

export function buildTeammateInboxLabelSectionExpandedKey(teammateNamespace: string) {
  return `${CollapsedItemKeyPrefixesEnum.TEAMMATE_INBOX}${teammateNamespace}`;
}
